import { Application } from '../../../../application/application'

import { isProfileStep } from './steps/profile-setup'
import { isBackgroundCheckStep } from './steps/background-check'
import { isApplicationClosedStep } from './steps/application-closed'
import { isJPNonCitizenGuideStep } from './steps/jp-non-citizen-guide'
import { isReScheduleStep } from './steps/re-schedule'
import { isProgressionStep } from './steps/progression-check'
import { isOrientationStep } from './steps/orientation'
import { isPlatformWorkflowStep } from './steps/platform-workflow'
import { Options } from './steps/interfaces'
import { STEPS, Steps, StepItem } from '../../../'

/**
 * determineCurrentStep
 *
 * @param application
 * @param options
 */
export function determineCurrentStepJapan(
  application: Application,
  options: Options
): StepItem {
  const profileStep = isProfileStep(application)
  const backgroundCheckStep = isBackgroundCheckStep(application, options)
  const applicationClosedStep = isApplicationClosedStep(application, options)
  const nonJPCitizenStep = isJPNonCitizenGuideStep(application)
  const rescheduleStep = isReScheduleStep(options)
  const progressionCheck = isProgressionStep(application, options)
  const orientationStep = isOrientationStep(application)
  const platformWorkflowStep = isPlatformWorkflowStep()

  if (platformWorkflowStep) {
    if (options.isDxOnboardingPlatformWorkflowComplete) {
      return STEPS[Steps.ProgressionCheck]
    }
    return STEPS[Steps.StartOnBoardingWorkflow]
  }

  if (profileStep) {
    return STEPS[Steps.ProfileSetup]
  }

  if (backgroundCheckStep) {
    return STEPS[Steps.BackgroundCheck]
  }

  if (applicationClosedStep) {
    return STEPS[Steps.ApplicationClosed]
  }

  if (nonJPCitizenStep) {
    return STEPS[Steps.JapanNonCitizenGuide]
  }

  if (rescheduleStep) {
    return STEPS[Steps.Reschedule]
  }

  if (progressionCheck) {
    return STEPS[Steps.ProgressionCheck]
  }

  if (orientationStep) {
    return STEPS[Steps.Orientation]
  }

  return null
}
